// TODO(ui-foundation): promote this component to ui-foundation and remove from this repo.
import { forwardRef, type ButtonHTMLAttributes } from "react";

export type AuthLinkButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const AuthLinkButton = forwardRef<
  HTMLButtonElement,
  AuthLinkButtonProps
>(function AuthLinkButton({ type = "button", className, ...rest }, ref) {
  const merged = className
    ? `events-auth-card__link ${className}`
    : "events-auth-card__link";
  return <button ref={ref} type={type} className={merged} {...rest} />;
});
